export const AUTH_ERROR_CODES = new Set(['AUTH_EXCEPTION', 'FORBIDDEN', 'UNAUTHENTICATED']);

const AUTH_LOGOUT = '/dashboard/logout';

export default function globalGraphQLErrorHandler({ errors }) {
  // Errors are ZBError instances with direct errorCode and message properties
  if (!errors?.length) {
    return;
  }

  const authError = errors.find((err) => AUTH_ERROR_CODES.has(err.errorCode));

  // If someone provides a bad UUID, force re-login
  const invalidRequestError = errors.find(
    ({ errorCode, message }) => (
      (errorCode === 'FORBIDDEN' && message === 'Permission failure')
      || (errorCode === 'BAD_USER_INPUT' && message?.includes('UUID cannot represent non-UUID'))
    )
  );

  // If the error is an authentication or invalid request error, redirect to the logout page
  if (authError || invalidRequestError) {
    const { pathname } = window.location;

    if (!pathname || !pathname.startsWith(AUTH_LOGOUT)) {
      window.location.assign(`${AUTH_LOGOUT}?redirectTo=${pathname}`);
    }
  }
}
